/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// eslint-disable-next-line import/prefer-default-export

export const splitAndCapitalize = (inputString) => {
    // Check if the inputString contains only words and add spaces between them

    if (/^[A-Za-z\s]+$/.test(inputString)) {
        return inputString.replace(/([A-Z][a-z]+)/g, ' $1').trim().replace(/\b\w/g, (c) => c.toUpperCase());
    }

    return inputString
        .replace(/next(\d+)([A-Z][a-z]*)|(\d+)([A-Z][a-z]*)([A-Z][a-z]*)|([A-Z][a-z]*)(\d+)([A-Z][a-z]*)|(\d+)([A-Z][a-z]*)|([A-Z][a-z]*)(\d+)|([A-Za-z]+\/[A-Za-z]+)/g,
            (match, group1, group2, group3, group4, group5, group6, group7, group8, group9, group10) => {
                if (group1) {
                    return `Next ${group1} ${group2}`;
                } if (group3 && group5) {
                    return `${group3} ${group4} ${group5}`;
                } if (group6 && group8) {
                    return `${group6} ${group7} ${group8}`;
                } if (group9 && group10) {
                    return `${group9} ${group10}`;
                }
                return match;
            })
        .trim()
        .split(' ')
        .map((word) => {
            if (/^\d+$/.test(word)) return word.trim();
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
};

// @Milo - ChatGPT suggests below function does the same thing as the splitAndCapitalize function above. Should we test this out?

// export const splitAndCapitalize(inputString) {
//     // Check if the inputString contains only words and spaces
//     if (/^[A-Za-z\s]+$/.test(inputString)) {
//         return inputString
//             .replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space between lowercase and uppercase letters
//             .split(' ')
//             .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//             .join(' ');
//     }

//     return inputString;
// }

// Be needs to provide occasion codes for the ones over 100
export const additionalOccasionsList = [
    {
        occasion: '6', desc: 'Easter', dateMM: '', dateDD: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '4', desc: 'Just Because', dateMM: '', dateDD: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '7', desc: 'Mother\'s Day', dateMM: '', dateDD: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '8', desc: 'Father\'s Day', dateMM: '', dateDD: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    },
    {
        occasion: '9', desc: 'Thanksgiving', dateMM: '', dateDD: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    },
    {
        occasion: '10', desc: 'Christmas', dateMM: '', dateDD: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '5', desc: 'Valentine\'s Day', dateMM: '', dateDD: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '1', desc: 'Anniversary', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '11', desc: 'Parents\' Day', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '12', desc: 'Friendship Day', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '13', desc: 'New Year’s', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '14', desc: 'Halloween', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '15', desc: 'Veteran’s Day', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '16', desc: 'Memorial Day', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '17', desc: 'Cinco de Mayo', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '18', desc: 'Hannukah', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '19', desc: 'Boss’ Day', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '20', desc: 'Eid', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    }, {
        occasion: '21', desc: 'Diwali', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone: '', reminderEmail: '', subscribed: true,
    },
];

export const anniversaryReminderGroup = [
    'Husband', 'Wife', 'Girlfriend', 'Boyfriend',
];

export const relationshipTypes = {
    Mom: '1',
    Dad: '2',
    Son: '3',
    Daughter: '4',
    Brother: '5',
    Sister: '6',
    Grandpa: '7',
    Grandma: '8',
    Uncle: '10',
    Aunt: '20',
    Husband: '14',
    Wife: '15',
    Boyfriend: '16',
    Girlfriend: '17',
    Friend: '18',
    Other: '19',
    Family: '21',
    Colleague: '22',
    Client: '23',
    Self: '0',
};

export const addressTypeOptions = ['Residence', 'Business', 'Funeral home', 'Hospital', 'Apartment', 'School', 'APO/FPO', 'P.O.Box', 'Church'];

export const addressTypes = {
    Residence: '1', Business: '2', 'Funeral home': '4', Hospital: '5', Apartment: '6', School: '8', 'APO/FPO': '9', 'P.O.Box': '10', Church: '11',
};

export const getIsShowingLocationTypeField = (watchLocationType) => !['Residence', 'Apartment', 'APO/FPO', 'P.O.Box'].includes(watchLocationType);

// DO NOT CHANGE THE KEY OF THE RELATIONSHIPMAPPING OBJECT BELOW.
// If this needs to be changed, make sure it is consistent with the Addressbook API documentation.
// https://1800flowers.gitlab.io/apps/retention/services/address-service-api/snapshot/api-guide/

const relationshipCollection = {
    0: 'Self',
    1: 'Mom',
    2: 'Dad',
    3: 'Son',
    4: 'Daughter',
    5: 'Brother',
    6: 'Sister',
    7: 'Grandpa',
    8: 'Grandma',
    10: 'Uncle',
    20: 'Aunt',
    14: 'Husband',
    15: 'Wife',
    16: 'Boyfriend',
    17: 'Girlfriend',
    18: 'Friend',
    19: 'Other',
    21: 'Family',
    22: 'Colleague',
    23: 'Client',
};

export const relationshipMapping = relationshipCollection;

export const modifiedRelationships = ({ recipientProfile, recipientState }) => {
    let isSelfRecipientAvailable = recipientProfile?.isSelfRecipientAvailable;

    if (!recipientProfile && recipientState?.addressBookResponse?.addressList?.length > 0) {
        isSelfRecipientAvailable = recipientState?.addressBookResponse?.addressList.find(address => +address.relationship === 0) ? true : false;
    }

    const relationships = { ...relationshipCollection };
    if (isSelfRecipientAvailable && recipientProfile?.relationship !== relationshipMapping[0]) {
        delete relationships[0];
    }

    return relationships;
};

export const emailTypes = ['Personal', 'Work'];

export const phoneNumberTypes = ['Mobile', 'Landline'];

export const locationTypeOptions = ['Residence', 'Business', 'Funeral home', 'Hospital', 'Apartment', 'School', 'APO/FPO', 'P.O.Box', 'Church'];

export const usStates = [
    'AA', 'AE', 'AK', 'AL', 'AP', 'AR', 'AS', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE',
    'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD',
    'ME', 'MI', 'MN', 'MO', 'MP', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM',
    'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'PW', 'RI', 'SC', 'SD', 'TN', 'TX',
    'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'
];

export const canStates = [
    'AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'
];

export const countries = ['United States', 'Canada'];

export const contryShort = {
    'United States': 'US',
    'Canada': 'CA',
};

export const occasionsMapping = {
    1: {
        name: 'Anniversary',
    },
    2: {
        name: 'Birthday',
    },
    4: {
        name: 'Just Because',
    },
    5: {
        name: 'Valentine\'s Day',
    },
    6: {
        name: 'Easter',
    },
    7: {
        name: 'Mother\'s Day',
    },
    8: {
        name: 'Father\'s Day',
    },
    9: {
        name: 'Thanksgiving',
    },
    10: {
        name: 'Christmas',
    },
    11: {
        name: 'Parents\' day',
    },
    12: {
        name: 'Friendship Day',
    },
    13: {
        name: 'New Year’s',
    },
    14: {
        name: 'Halloween',
    },
    15: {
        name: 'Veteran’s Day',
    },
    16: {
        name: 'Memorial Day',
    },
    17: {
        name: 'Cinco de Mayo',
    },
    18: {
        name: 'Hannukah',
    },
    19: {
        name: 'Boss’ Day',
    },
    20: {
        name: 'Eid',
    },
    21: {
        name: 'Diwali',
    },
};

export const getAddressTypeNickName = (addressType) => {
    if (['Residence', 'Apartment'].includes(addressType)) {
        return 'Home';
    } if (addressType === 'Business') {
        return 'Work';
    }
    return addressType || 'Residence';
};

export const formatNameToProperCapitalization = (fullName) => {
    // DO NOT use this function to format data for display. The data should be sent to the API in proper case formatting.
    if (fullName.trim() !== '') {
        return fullName
            .split(/\s+/)
            .map((firstOrLastName) => firstOrLastName && `${firstOrLastName[0]?.toUpperCase()}${firstOrLastName.slice(1).toLowerCase()}`)
            .join(' ');
    }
    return '';
}

// TODO: Dry up below exports into a helper function
export const days = (month) => (
    Array.from(
        {length: new Date(new Date().getFullYear(), month, 0).getDate()}, // get next month, zeroth's (previous) day
        (_, i) => new Date(0, 0, i + 1).toLocaleDateString('en-US', { day: '2-digit' })
    )
);

export const years = Array.from({ length: 100 }, (_, i) => {
    if (i === 0) return '';
    return new Date().getFullYear() - (i - 1);
});

export const monthsMM = Array.from({ length: 12 }, (_, i) => new Date(0, i).toLocaleString('en-US', { month: '2-digit' }));

export const monthsLong = Array.from({ length: 12 }, (_, i) => new Date(0, i).toLocaleString('en-US', { month: 'long' }));

export const monthsShort = Array.from({ length: 12 }, (_, i) => new Date(0, i).toLocaleString('en-US', { month: 'short' }));

export const sortRecipients = (option, addressBookResponse) => {
    if (addressBookResponse?.addressList?.length > 1) {
        if (option === 'reminders') {
            const today = new Date();
            const reminderRecipients = [];
            const noUpcomingReminders = [];

            // Loop through the address list and categorize recipients into two groups
            addressBookResponse?.addressList.forEach((recipient) => {
                const upcomingReminders = recipient.occasions?.length > 0 && recipient.occasions.filter((occasion) => {
                    if (
                        occasion.dateMM !== undefined
                        && occasion.dateDD !== undefined
                        && (occasion.subscribedPhone || occasion.subscribedEmail)
                    ) {
                        const reminderDate = new Date(today);
                        reminderDate.setMonth(occasion.dateMM - 1); // Months are zero-based
                        reminderDate.setDate(occasion.dateDD);
                        // Include reminders for occasions with date later than today
                        if (reminderDate >= today) {
                            return true;
                        }
                    }
                    return false;
                });

                if (upcomingReminders.length > 0) {
                    // Sort the upcoming reminders by the closest upcoming date
                    upcomingReminders.sort((a, b) => {
                        const aReminderDate = new Date(today);
                        aReminderDate.setMonth(a.dateMM - 1);
                        aReminderDate.setDate(a.dateDD);

                        const bReminderDate = new Date(today);
                        bReminderDate.setMonth(b.dateMM - 1);
                        bReminderDate.setDate(b.dateDD);

                        return aReminderDate - bReminderDate;
                    });

                    // Push the recipient object with all occasions, now sorted by upcoming reminder dates, to the reminderRecipients array
                    reminderRecipients.push({
                        ...recipient,
                        // Check for duplicate occasions by comparing dateDD, dateMM, occasion.
                        occasions: [...upcomingReminders, ...recipient.occasions.filter((occasion) => !upcomingReminders.some((upcomingOccasion) => (
                            occasion.dateDD === upcomingOccasion.dateDD
                               && occasion.dateMM === upcomingOccasion.dateMM
                               && occasion.occasion === upcomingOccasion.occasion
                        ),
                        ))],
                    });
                } else {
                    noUpcomingReminders.push({ ...recipient, occasions: recipient.occasions });
                }
            });

            // Sort the reminderRecipients by the earliest reminder date (including today)
            reminderRecipients.sort((a, b) => {
                const aEarliestReminder = a.occasions[0]
                    ? new Date(today)
                    : today;
                aEarliestReminder.setMonth(a.occasions[0].dateMM - 1);
                aEarliestReminder.setDate(a.occasions[0].dateDD);
                const bEarliestReminder = b.occasions[0]
                    ? new Date(today)
                    : today;
                bEarliestReminder.setMonth(b.occasions[0].dateMM - 1);
                bEarliestReminder.setDate(b.occasions[0].dateDD);

                return aEarliestReminder - bEarliestReminder;
            });
            // Sort the noUpcomingReminders by the earliest date (day and month) for subscribed occasions, only for recipients with reminders
            noUpcomingReminders.sort((a, b) => {
                const aEarliestSubscribedOccasion = a.occasions?.length > 0
                    ? a.occasions
                        .filter((occasion) => occasion.subscribed)
                        .reduce((earliest, occasion) => {
                            const occasionDate = new Date(today);
                            occasionDate.setMonth(occasion.dateMM - 1);
                            occasionDate.setDate(occasion.dateDD);
                            // eslint-disable-next-line no-nested-ternary
                            return earliest ? (occasionDate < earliest ? occasionDate : earliest) : occasionDate;
                        }, null)
                    : null;

                const bEarliestSubscribedOccasion = b.occasions?.length > 0
                    ? b.occasions
                        .filter((occasion) => occasion.subscribed)
                        .reduce((earliest, occasion) => {
                            const occasionDate = new Date(today);
                            occasionDate.setMonth(occasion.dateMM - 1);
                            occasionDate.setDate(occasion.dateDD);
                            // eslint-disable-next-line no-nested-ternary
                            return earliest ? (occasionDate < earliest ? occasionDate : earliest) : occasionDate;
                        }, null)
                    : null;

                if (!aEarliestSubscribedOccasion) return 1; // Sort recipients without subscribed occasions to the end
                if (!bEarliestSubscribedOccasion) return -1;

                return aEarliestSubscribedOccasion - bEarliestSubscribedOccasion;
            });
            return [...reminderRecipients, ...noUpcomingReminders];
        } if (option === 'asc') {
            return addressBookResponse?.addressList.sort((a, b) => a.rcpLastName?.localeCompare(b.rcpLastName));
        } if (option === 'desc') {
            return addressBookResponse?.addressList.sort((a, b) => b.rcpLastName?.localeCompare(a.rcpLastName));
        }
    }
    return addressBookResponse?.addressList || [];
};

export const sortOccasionsByDate = (occasions) => {
    // Check if the array is empty
    if (occasions.length === 0) {
      return [];
    }
    
    // Sort the array based on dateDD and dateMM
    occasions.sort((a, b) => {
      // Concatenate dateMM and dateDD to create a string in 'MMDD' format
      const dateA = `${a?.dateMM}${a?.dateDD}`;
      const dateB = `${b?.dateMM}${b?.dateDD}`;
      
      // Compare the concatenated dates
      return dateA.localeCompare(dateB);
    });
    
    // Return sorted array
    return occasions;
}

export const unmaskPhoneNumber = (maskedInput) => {
    if (maskedInput === '' || maskedInput === undefined) {
        return '';
    }
    return maskedInput.replace(/\D/g, '');
}

export const maskPhoneNumber = (phoneNumber) => {
    if (phoneNumber === '' || phoneNumber === undefined) {
        return '';
    }
    // Remove all non-digit characters from the input phone number
    const digitsOnly = phoneNumber.replace(/\D/g, '');

    // Apply the mask pattern to the digits
    const maskedNumber = digitsOnly.replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');

    return maskedNumber;
}

export const focusOnElement = ({ selectorInputToSearch }) => typeof document !== 'undefined' && setTimeout(() => document?.querySelector(selectorInputToSearch)?.focus(), 200);